<!-- Created by jack on 2022/2/28 - 10:55 -->
<style scoped lang="less">
.box{
  display: grid;
  grid-template-columns: repeat(3,33.3%);
  grid-row-gap: 16px;
  &__title{
    width: 100%;
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 12px;
    text-align: center;
    color: #A1A4A9;
  }
  &__value{
    width: 100%;
    margin-top: 8px;
    font-family: number-bold;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    text-align: center;
    color: #141B27;

  }
  &__focus{
    color: #FF5000;
  }
}
</style>

<template>
  <div class="box">
    <div>
      <div class="box__title">商品数</div>
      <div class="box__value">{{ baseData.commodityCount }}</div>
    </div>
    <div>
      <div class="box__title">直播销量</div>
      <div class="box__value">{{ baseData.salesVolume }}</div>
    </div>
    <div>
      <div class="box__title">直播销售额</div>
      <div class="box__value box__focus">
        {{ baseData.sales }}
        <span class="vip-icon"  v-if="!$store.getters.isVip">VIP</span>
      </div>
    </div>
    <div>
      <div class="box__title">商品均价</div>
      <div class="box__value">{{ baseData.commodityAvgPrice }}</div>
    </div>
    <div>
      <div class="box__title">关联品牌</div>
      <div class="box__value">{{ baseData.brandSalesVolume }}</div>
    </div>
    <div>
      <div class="box__title">合作店铺</div>
      <div class="box__value">{{ baseData.cooperationShopCount }}</div>
    </div>
    <div>
      <div class="box__title">带货场次</div>
      <div class="box__value">{{ baseData.liveStreamCount }}</div>
    </div>
    <div>
      <div class="box__title">客单价</div>
      <div class="box__value">{{ baseData.atv }}</div>
    </div>
    <div>
      <div class="box__title">带货转化率</div>
      <div class="box__value">{{ baseData.commodityCR }}</div>
    </div>
  </div>
</template>

<script>
import {dateLongDuration, retainWan} from "@/plugins/helper";

export default {
  props:{
    data:{ type:Object,default: () => ({}) }
  },
  computed: {
    baseData: (_this = this) => ({
      commodityCount: _this.$props.data?.commodityCount ? retainWan(_this.$props.data.commodityCount) : '-', // 商品数
      salesVolume: _this.$props.data?.salesVolume ? retainWan(_this.$props.data.salesVolume) : '-', // 销量
      sales:_this.$props.data?.sales ? '¥' + retainWan(_this.$props.data.sales) : '-', // 销售额

      commodityAvgPrice:_this.$props.data?.commodityAvgPrice ?'¥' + retainWan(_this.$props.data.commodityAvgPrice) : '-', // 商品均价
      brandSalesVolume: _this.$props.data?.brandSalesVolume ? retainWan(_this.$props.data.brandSalesVolume) : '-', // 带货品牌数
      cooperationShopCount: _this.$props.data?.cooperationShopCount ? retainWan(_this.$props.data.cooperationShopCount) : '-', // 合作店铺数

      liveStreamCount: _this.$props.data?.liveStreamCount ? retainWan(_this.$props.data.liveStreamCount) : '-', // 带货场次
      atv: _this.$props.data?.atv ? '¥' + retainWan(_this.$props.data.atv) : '-', // 客单价
      commodityCR:_this.$props.data?.commodityCR ? _this.$props.data.commodityCR + '%' : '-', // 带货转化率
    })
  }
}
</script>
